import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageLayout from 'components/layouts/PageLayout';
import SectionLayout from 'components/layouts/SectionLayout';
import PageNotFoundContent from './content/PageNotFoundContent';

const PageNotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Page Not Found";

    if (typeof window !== 'undefined') {
      const fullHref = (window.location.href || '').toLowerCase();
      const pathname = (window.location.pathname || '').toLowerCase();
      const search = (window.location.search || '').toLowerCase();

      // Check if URL contains email marketing, UTMs, or lump sum parameters in path or query
      const isLumpSumRedirect =
        pathname.includes('utm_source') ||
        pathname.includes('utm_medium') ||
        pathname.includes('utm_campaign') ||
        pathname.includes('lump') ||
        pathname.includes('benefit') ||
        pathname.includes('cancer') ||
        search.includes('utm_source=email') ||
        search.includes('utm_medium=email') ||
        search.includes('email%20marketing') ||
        fullHref.includes('utm_source=email') ||
        fullHref.includes('email%20marketing');

      if (isLumpSumRedirect) {
        // If query parameters were accidentally appended as path (e.g. /utm_source=email&utm_medium=...)
        let targetSearch = window.location.search;
        if (!targetSearch && pathname.includes('=')) {
          const rawQuery = window.location.pathname.replace(/^\/+/, '');
          targetSearch = '?' + rawQuery;
        }
        navigate('/calculators/lump-sum-benefits' + targetSearch, { replace: true });
      }
    }
  }, [navigate]);

  return (
    <PageLayout
      content={<SectionLayout content={PageNotFoundContent} />}
    />
  );
};

export default PageNotFound;
